import styled from "styled-components"

const YearFilter = styled.div`
  cursor: pointer;
  font-weight: bold;
  &::after {
    background-color: ${(props) =>
      props.active === true
        ? props.theme.b_color_gradients.b_light
        : props.theme.b_color_gradients.b_dark} !important;
  }

  text-decoration: ${(props) =>
    props.active === true ? "dashed underline" : "none"};
`

const MonthFilter = styled.p`
  color: ${(props) =>
    props.active === true
      ? props.theme.b_color_gradients.b_dark
      : props.theme.c_color_gradients.c_dark};

  text-decoration: ${(props) =>
    props.active === true ? "dashed underline" : "none"};
`

export { YearFilter, MonthFilter }
